import { render, staticRenderFns } from "./UsuariosComunicante.vue?vue&type=template&id=7436ea58&"
import script from "./UsuariosComunicante.vue?vue&type=script&lang=js&"
export * from "./UsuariosComunicante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports